import { startCase } from 'lodash-es';

/**
 * NOTE: 화면에서는 message-queue 사용하지만 응답은 'message_queue'로 옴
 * enum으로 정의된 것이라 수정하기 어렵다함
 */
// 요청 시 변환
export const convertPlatform = (platform: string): string => {
  switch (platform) {
    case 'message-queue':
      return 'message_queue';
    default:
      return platform;
  }
};
// 응답 시 변환
export const convertMenuPaths = (paths: string[]): string[] => {
  return paths.map((path) => {
    switch (path) {
      case 'message_queue':
        return 'message-queue';
      default:
        return path;
    }
  });
};

// NOTE: platform tag 관련 키 변환
export const getMenuPathKey = (key: string): string => {
  const formatKey = key.replace(/_/g, '-');

  switch (formatKey) {
    case 'k8s':
      return 'Kubernetes';
    case 'message-queue':
      return 'Message-Queue';
    default:
      return startCase(formatKey);
  }
};
